export enum ReservationMode {
  ANYONE = "anyone",
  OWNERS = "owners",
  OWNERS_AND_USERS = "owners and users",
}
